import { TextField} from '@material-ui/core'
import { Field } from 'formik';

const CustomTextField = (props: ICustomTextFieldProps) => {
    return (
        <Field
            name={props.name}
            placeholder={props.placeholder}
            type={props.type}
            value={props?.value ? props?.value : props.formik.values[props.name] ?? ''}
            required={props.required}
            component={TextField}
            onChange={(e: any) => {
                props.formik.handleChange(props.name)(e);
                if (props.onChange) {// If user send onchange trigger method then trigger function for changed value
                    props.onChange(e.target.value)
                }
            }
            }
            error={props.formik.touched[props.name] && Boolean(props.formik.errors[props.name])}
            helperText={props.formik.touched[props.name] && props.formik.errors[props.name] != undefined ? props.formik.errors[props.name] : props.helperText}
            autoFocus={props.autoFocus}
            color="primary"
            size="small"
            fullWidth
            select={props.select}
            children={props.children}
            InputProps={{
                ...props.InputProps,
                notched: false,
                disableUnderline: props.noUnderline,
                classes: {
                    ...props.InputProps?.classes,
                },
            }}
            className={props.className}
            label={props.label}
            disabled={props.disabled}
            id={`custom-css-outlined-input-${props.name}`}
        />
    )
}

export interface ICustomTextFieldProps {
    label: string;
    name: string;
    placeholder: string;
    InputProps?: any;
    type?: string;
    required?: boolean;
    formik: any;
    fullWidth?: boolean;
    disabled?: boolean;
    className?: string;
    autoFocus?: boolean;
    select?: boolean;
    children?: any;
    onChange?: any;
    value?: string;
    helperText?: string;
    noUnderline?:boolean;
}

export default CustomTextField;